var _circle, _circle2, _circle3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 637,
    viewBox: "0 -59 637 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 204.185,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 304.5,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 112.854,
    fill: "#212C42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2265_3742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.5 284.81C327.925 284.958 333.958 278.946 333.958 271.5C333.958 264.054 327.925 258.042 320.5 258C313.075 258.042 307.042 264.054 307.042 271.5C307.042 278.946 313.075 284.958 320.5 284.81ZM325.52 291.75H315.501C307.084 291.75 300.25 298.816 300.25 307.507C300.25 309.975 302.212 312 304.638 312H336.341C338.788 312 340.75 309.975 340.75 307.507C340.75 298.816 333.916 291.75 325.52 291.75ZM372.77 291.75H362.751C354.334 291.75 347.5 298.816 347.5 307.507C347.5 309.975 349.462 312 351.887 312H383.591C386.038 312 388 309.975 388 307.507C388 298.816 381.166 291.75 372.77 291.75ZM367.75 284.81C375.175 284.958 381.208 278.946 381.208 271.5C381.208 264.054 375.175 258.042 367.75 258C360.325 258.042 354.292 264.054 354.292 271.5C354.292 278.946 360.325 284.958 367.75 284.81ZM273.25 284.81C280.675 284.958 286.708 278.946 286.708 271.5C286.708 264.054 280.675 258.042 273.25 258C265.821 258.042 259.794 264.054 259.794 271.5C259.794 278.946 265.821 284.958 273.25 284.81ZM278.27 291.75H268.251C259.839 291.75 253 298.816 253 307.507C253 309.975 254.97 312 257.394 312H289.098C291.538 312 293.5 309.975 293.5 307.507C293.5 298.816 286.666 291.75 278.27 291.75Z",
    fill: "#719CF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M273.25 217.5H367.75V251.25C372.943 251.25 377.664 253.28 381.25 256.523V214.469C381.25 208.693 376.715 204 371.125 204H269.875C264.285 204 259.75 208.693 259.75 214.469V256.53C263.336 253.286 268.057 251.256 273.25 251.256V217.5Z",
    fill: "#719CF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2265_3742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 108,
    fill: "white",
    transform: "translate(253 204)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainTeam);
export default __webpack_public_path__ + "static/media/train-team.c0a7ca08e85f244de32c6a2197b3e209.svg";
export { ForwardRef as ReactComponent };